<template>
  <section v-if="testContent != null">
    <template v-if="!started">
      <table class="table my-4">
        <tbody>
          <tr>
            <th class="text-end">
              テスト名
            </th>
            <td>
              {{testName}}
            </td>
          </tr>
          <tr>
            <th class="text-end">
              テスト回答形式
            </th>
            <td>
              {{testContent.testAnswerFormat == "Bulk" ? "一括回答" : "一問一答"}}
            </td>
          </tr>
          <tr>
            <th class="text-end">
              出題順
            </th>
            <td>
              {{testContent.orderOfQuestions == "Random" ? "ランダム" : "固定"}}
            </td>
          </tr>
          <tr>
            <th class="text-end">
              出題数
            </th>
            <td>
              {{testContent.questionCount}}
            </td>
          </tr>
          <tr>
            <th class="text-end">
              合格点数
            </th>
            <td>
              {{testContent.passingScore}}
            </td>
          </tr>
          <tr>
            <th class="text-end">
              制限時間
            </th>
            <td>
              {{testContent.setTimeLimit == 1 ? testContent.timeLimit : "なし"}}
            </td>
          </tr>
        </tbody>
      </table>

      <section class="my-4">
        <button type="button" class="btn btn-primary w-100" v-on:click="startTest()">
          開始
        </button>
      </section>
    </template>

    <template v-if="started && testContent.testAnswerFormat == 'Bulk'">
      <section v-for="(question, questionIndex) in testContent.questions">
        <section class="my-4 border-bottom">
          <h6 class="my-4">
            問題 {{questionIndex + 1}}
          </h6>
          <div class="my-4">
            {{question.questionBody}}
          </div>
        </section>
        <section class="my-4 border-bottom user-select-none">
          <h6 class="my-4">
            回答
          </h6>

          <template v-if="question.answerMethod=='choice'">
            <section class="my-4">
              <div v-for="choice in question.choices"
                   class="p-2 border rounded-3 d-flex align-items-center my-2">
                <input type="checkbox" :name="'__choices_' + question.id" :id="'__choices_' + question.id + '_' + choice.id" :value="choice.id"
                       class="form-check-input mx-2 my-auto" />
                <label :for="'__choices_' + question.id + '_' + choice.id"
                       class="form-check-label flex-grow-1">
                  {{choice.detail}}
                </label>
              </div>
            </section>
          </template>

          <template v-if="question.answerMethod=='sort'">
            <draggable v-model="question.choices"
                       item-key="question.choices"
                       handle=".handle"
                       animation="300">
              <template #item="{element}">
                <div v-bind:key="element.id"
                     class="d-flex align-items-center handle border rounded-3 p-2 my-2"
                     role="row">
                  <svgicon role="gridcell" name="list" />
                  <span role="gridcell" class="ms-2 flex-grow-1">{{element.detail}}</span>
                </div>
              </template>
            </draggable>
          </template>

          <template v-if="question.answerMethod=='input'">
            <input type="text" class="form-control my-4" />
          </template>

        </section>
      </section>
    </template>

    <template v-if="started && testContent.testAnswerFormat != 'Bulk'">
      <section>
        <section class="my-4 border-bottom">
          <h6 class="my-4">
            問題 {{questionIndex + 1}}
          </h6>
          <div class="my-4">
            {{selectedQuestion.questionBody}}
          </div>
        </section>
        <section class="my-4 border-bottom user-select-none">
          <h6 class="my-4">
            回答
          </h6>

          <template v-if="selectedQuestion.answerMethod=='choice'">
            <section class="my-4">
              <div v-for="choice in selectedQuestion.choices"
                   class="p-2 border rounded-3 d-flex align-items-center my-2">
                <input type="checkbox" :name="'__choices_' + selectedQuestion.id" :id="'__choices_' + selectedQuestion.id + '_' + choice.id" :value="choice.id"
                       class="form-check-input mx-2 my-auto" />
                <label :for="'__choices_' + selectedQuestion.id + '_' + choice.id"
                       class="form-check-label flex-grow-1">
                  {{choice.detail}}
                </label>
              </div>
            </section>
          </template>

          <template v-if="selectedQuestion.answerMethod=='sort'">
            <draggable v-model="selectedQuestion.choices"
                       item-key="selectedQuestion.choices"
                       handle=".handle"
                       animation="300">
              <template #item="{element}">
                <div v-bind:key="element.id"
                     class="d-flex align-items-center handle border rounded-3 p-2 my-2"
                     role="row">
                  <svgicon role="gridcell" name="list" />
                  <span role="gridcell" class="ms-2 flex-grow-1">{{element.detail}}</span>
                </div>
              </template>
            </draggable>
          </template>

          <template v-if="selectedQuestion.answerMethod=='input'">
            <input type="text" class="form-control my-4" />
          </template>

        </section>
      </section>

      <section class="d-flex">
        <button type="button"
                class="btn btn-outline-success me-auto"
                v-on:click="moveQuestion(-1)"
                v-if="!firstQuestionSelected">
          前の問題
        </button>
        <button type="button"
                class="btn btn-outline-primary ms-auto"
                v-on:click="moveQuestion(1)"
                v-if="!lastQuestionSelected">
          次の問題
        </button>
      </section>
    </template>
  </section>
</template>

<script>
  import { defineComponent } from "vue";
  import draggable from "vuedraggable";

  export default defineComponent({
    props: {
      test: {
        type: Object,
        required: true,
      },
      testName: {
        type: String,
        default: null,
      },
    },
    computed: {
      selectedQuestion() {
        if (this.testContent == null) return null;
        return this.testContent.questions[this.questionIndex];
      },
      firstQuestionSelected() {
        return this.questionIndex === 0;
      },
      lastQuestionSelected() {
        return this.testContent.questions.length - 1 === this.questionIndex;
      },
    },
    data: () => {
      return {
        testContent: null,
        started: false,
        questionIndex: 0,
      }
    },
    methods: {
      startTest() {
        this.started = true;
      },
      moveQuestion(num) {
        let val = this.questionIndex + (num);
        if (0 <= val && val < this.testContent.questions.length) this.questionIndex = val;
      },
    },
    beforeCreate() {
    },
    created() {
    },
    mounted() {
      this.testContent = this.test;
    },
    emits: ["start",],
    components: {
      "draggable": draggable,
    },
    watch: {
    }
  });

</script>
